<template>
  <section>
    <label>
        <small v-if="eventoId.required" class="text-danger">*</small> Tipo de Evento:
    </label>
    <div class="input-group">
      <b-form-select
        @change="onSelect()"
        :required="eventoId.required"
        v-model="eventoId.value"
        :options="eventoId.listOptions"
        class="w-100"
        label="text"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>{{ $lang.Common.PlaceholderSelect }}</b-form-select-option>
        </template>
      </b-form-select>
    </div>
  </section>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import EventRepository from '@/shared/http/repositories/configurations/event.js'

export default {
  name: 'SelectEvento',
  mixins: [ ActionsForm ],
  props: {
    selectedOption: {
      type: Number | String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      eventoId: { listOptions: [], value: null, required: true }
    }
  },
  created () {
    this.onLoadAllEventType()
  },
  watch: {
    selectedOption: {
      immediate: true,
      handler: function (newVal) {
        this.eventoId.value = newVal
      }
    }
  },
  methods: {
    async onLoadAllEventType () {
      this.eventoId.listOptions = []
      try {
        loading.push()
        const activeEvents = await EventRepository.GetAllActive()

        if (!activeEvents || !activeEvents.data || !activeEvents.data.content || activeEvents.data.content.length === 0) {
          return
        }

        activeEvents.data.content
          .filter(event => event.tipoEventoDTO.nome !== 'CRM')
          .map(event => event.tipoEventoDTO.nome)
          .filter((value, index, self) => self.indexOf(value) === index)
          .forEach(eventType => {
            this.eventoId.listOptions.push({
              label: eventType,
              options: activeEvents.data.content
                .filter(e => e.tipoEventoDTO.nome === eventType)
                .map(e => ({ value: e.id, text: e.nome, mnemonic: e.mnemonic }))
            })
          })
      } catch (error) {
        this.onException(error)
      } finally {
        loading.close()
      }
    },
    onSelect () {
      this.$emit('onSelect', this.eventoId.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/selects/SelectEvento.vue